import requisites from './lists/requisites';
import requisitesGroups from './lists/requisites-groups'
import templates from './lists/templates';
import workflows from './lists/workflows';

export default {
    namespaced: true,
    state: () => ({
        collection : "Requisites",
        searches: [
            { collection: "Requisites", value: "" },
            { collection: "RequisitesGroups", value: "" },
            { collection: "Templates", value: "" },
            { collection: "Workflows", value: "" }
        ],
        requisiteTypes: [
            { id: 0, value: "Текст" },
            { id: 1, value: "Логический" },
            { id: 2, value: "Дата" },
            { id: 3, value: "Сотрудник" },
            { id: 4, value: "Организация" }
        ],
        workFlowDocTypes: [
            { id: 'Avrora.Objects.Modules.Docflow.DocflowObjects.OutgoingDocument', name: 'Исходящие'},
            { id: 'Avrora.Objects.Modules.Docflow.DocflowObjects.IncomingDocument', name: 'Входящие'},
            { id: 'Avrora.Objects.Modules.Docflow.DocflowObjects.InnerDocument', name: 'Внутренние'}
        ]
    }),
    mutations: {
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
        PUSH_SEARCH (state, payload) {
            let exists = state.searches.find(x => x.collection == state.collection);

            if (exists) {
                exists.value = payload.value;
            }
            else {
                state.searches.push(payload);
            }
        }
    },
    getters: {
        getCollection: (s) => s.collection,
        getSearch: (s) => s.searches.find(x => x.collection === s.collection)?.value,
        getRequisiteTypes: (s) => s.requisiteTypes,        
        getWorkFlowDocTypes: (s) => s.workFlowDocTypes
    },
    modules: {
        requisites,
        requisitesGroups,
        templates,
        workflows
    }
}